import React from 'react';
import { InfoTooltip } from '../info-tooltip/InfoTooltip';
import './ContentBox.scss';

export const ContentBox = ({
    size,
    contentBoxStyle,
    style,
    title,
    subtitle,
    tooltipMessage,
    content
}) => (
    <div
        className={contentBoxStyle || 'content-box ' + size}
        style={style || {}}
    >
        <div className="content-box-header">
            <span className="title">{title}</span>
            {subtitle && <span className="subtitle">{subtitle}</span>}
            {tooltipMessage && <InfoTooltip message={tooltipMessage} />}
        </div>
        <div className="content-box-content">{content}</div>
    </div>
);
